export default __webpack_public_path__ + "static/media/SarahBakula.02cb6ce3.jpg";